div<template>
  <form id="abc">
    <div class="main-wrapper">
      <div v-if="!isBankrupt">
        <div class="main-wrapper-checkboxes">
          <div v-if="!reputationsIsLoading">
            <p class="necessary-bold">
              <span
                :class="validateReputation() ? 'valid-field' : 'unvalid-field'"
                >➤</span
              >
              Сведения о деловой репутации:
            </p>
            <div class="checkboxes">
              <label v-for="reputation in reputations" :key="reputation.ID">
                <input
                  type="checkbox"
                  v-model="reputation.CHECKED"
                  @click="onCheckReputation(reputation.ID)"
                  :disabled="
                    lessThreeMonths ||
                      (pageInfo.DISABLED != null &&
                        pageInfo.DISABLED.indexOf('BUSINESS_REPUTATION') != -1)
                  "
                />
                {{ reputation.VALUE }}
              </label>
            </div>
          </div>
        </div>
        <p
          :class="
            !(validateFiles() || checkedValues.length > 0)
              ? 'necessary-table-not'
              : 'necessary-table'
          "
        >
          Приложите хотя бы один документ или выберите элемент из списка.
        </p>
        <p class="min-one-file">
          Вы можете приложить только один файл или архив. Если необходимо
          приложить несколько документов, добавьте документы в архив и
          прикрепите архив.
        </p>
        <div class="main-wrapper-table">
          <table>
            <tr v-for="file in files" :key="file.id">
              <td width="5%">
                <input
                  type="checkbox"
                  v-model="file.checkbox"
                  @click="onClickCheckBox(file.id)"
                  :disabled="!file.checkbox"
                />
              </td>
              <td>
                <p>{{ file.CAPTION }}</p>
              </td>
              <td width="310px" class="last-column">
                <input
                  v-show="file.FILE == null"
                  type="file"
                  id="file"
                  ref="file"
                  accept="image/*, .pdf, .zip, .7z, .xls, .xlsx"
                  v-on:change="uploadFile(file.id)"
                  @click="file.FILE = null"
                  :disabled="file.DISABLED != null && file.DISABLED"
                />
                <div
                  class="file-name-icon"
                  v-if="file.FILE != null"
                  @click="onClickBan(file.id)"
                >
                  <div class="icons">
                    <i class="fa fa-trash"></i>
                  </div>
                  <p class="file-name">{{ file.FILE.name }}</p>
                </div>
              </td>
            </tr>
            <tr v-for="item in tableCheckboxes" :key="item">
              <td width="5%">
                <input
                  type="checkbox"
                  :id="'checkbox-' + tableCheckboxes.indexOf(item)"
                  :value="item"
                  v-model="checkedValues"
                  :disabled="
                    pageInfo.DISABLED != null &&
                      pageInfo.DISABLED.indexOf('GIVE_REPUTATION_DOCS_LATER') !=
                        -1
                  "
                />
              </td>
              <td>
                <p>
                  <label :for="'checkbox-' + tableCheckboxes.indexOf(item)">{{
                    item
                  }}</label>
                </p>
              </td>
              <td width="310px" class="last-column"></td>
            </tr>
          </table>
        </div>
      </div>
      <div class="main-wrapper-checkboxes">
        <p class="necessary-bold">
          <span
            :class="
              validateSources() && validateAnotherSource()
                ? 'valid-field'
                : 'unvalid-field'
            "
            >➤</span
          >
          Сведения об источниках происхождения денежных средств и (или) иного
          имущества клиента:
        </p>
        <label v-for="source in sources" :key="source.ID">
          <input
            type="checkbox"
            v-model="source.CHECKED"
            @click="
              source.VALUE.toLowerCase() == 'иное'
                ? (anotherFounds = '')
                : source.VALUE
            "
            :disabled="
              pageInfo.DISABLED != null &&
                pageInfo.DISABLED.indexOf('FOUNDS_BASE_INFO') != -1
            "
          />
          {{ source.VALUE }}
        </label>
        <input
          type="text"
          v-if="
            sources[sources.length - 1] != null &&
              sources[sources.length - 1].CHECKED
          "
          v-model="anotherFounds"
          placeholder="Укажите иной источник"
          :onchanged="
            anotherFounds != null && anotherFounds.length > 255
              ? (anotherFounds = anotherFounds.substr(0, 255))
              : anotherFounds
          "
          :disabled="
            pageInfo.DISABLED != null &&
              pageInfo.DISABLED.indexOf('FOUNDS_BASE_INFO') != -1
          "
        />
      </div>
    </div>
  </form>
</template>

<script>
export default {
  name: "ReputationInfo",
  props: {
    finPosition: Number,
    pageName: String,
    pageInfo: {},
    bankName: String,
    isIP: Boolean,
  },
  data: () => ({
    reputationsIsLoading: true,
    reputations: [],
    selectedReputation: 0,
    anotherFounds: "",
    sources: [],
    files: [],
    isBankrupt: false,
    tableCheckboxes: [
      "Обязуемся подготовить документ для последующего предоставления",
    ],
    checkedValues: [],
    INN: "",
    ID: "",
    lessThreeMonths: false,
    PAGE: 1,
    sendData: {},
  }),
  methods: {
    onClickBan(id) {
      if (this.files[id].DISABLED == null || !this.files[id].DISABLED) {
        this.files[id].FILE = null;
        this.files[id].checkbox = false;
        let input = this.$refs.file[id];
        input.type = "text";
        input.type = "file";
        this.validation();
        this.$emit("updated");
      }
    },
    uploadFile(id) {
      if (this.checkFiles(this.$refs.file[id].files[0])) {
        let input = this.$refs.file[id];
        input.type = "text";
        input.type = "file";
      } else this.files[id].FILE = this.$refs.file[id].files[0];
      this.files[id].checkbox = this.files[id].FILE != null;
      this.validation();
      this.$emit("updated");
    },
    onClickCheckBox(id) {
      this.files[id].FILE = null;
      let input = this.$refs.file[id];
      input.type = "text";
      input.type = "file";
      this.validation();
      this.$emit("updated");
    },
    checkFiles(file) {
      let a = false;
      this.files.forEach((item) => {
        if (item.FILE != null) {
          a = a || item.FILE.name == file.name;
        }
      });
      if (a) this.$alert("Файл " + file.name + " уже загружен");
      else if (file.size > 31457280) {
        this.$alert(
          "Размер файла " + file.name + " превышает допустимый размер (30 МБ)"
        );
        a = true;
      }
      return a;
    },
    onCheckSource(ID) {
      this.sources.forEach((item) => {
        if (item.ID != ID) item.CHECKED = false;
      });
    },
    onCheckReputation(ID) {
      this.reputations.forEach((item) => {
        if (item.ID != ID) item.CHECKED = false;
      });
    },
    validateReputation() {
      let a = false;
      this.reputations.forEach((item) => (a = a || item.CHECKED));
      return a;
    },
    validateAnotherSource() {
      return (
        !this.sources[this.sources.length - 1].CHECKED ||
        (this.sources[this.sources.length - 1].CHECKED &&
          this.anotherFounds.length > 0)
      );
    },
    validateSources() {
      let a = false;
      this.sources.forEach((item) => (a = a || item.CHECKED));
      return a;
    },
    validateFiles() {
      let a = false;
      this.files.forEach((item) => (a = a || item.FILE != null));
      return a;
    },
    validation() {
      var msg = "";
      if (!this.validateReputation() && !this.isBankrupt)
        msg += "Предоставьте сведение о деловой репутации<br>";
      if (
        !(this.validateFiles() || this.checkedValues.length > 0) &&
        !this.isBankrupt
      )
        msg += "Приложите хотя бы один документ<br>";
      if (!this.validateSources())
        msg +=
          "Предоставьте сведение об источниках происхождения денежных средств<br>";
      if (!this.validateAnotherSource()) msg += "Заполните поле 'Иное'";
      this.$emit("enableButtons", true, msg);
      if (msg.length == 0) {
        if (!this.isBankrupt) {
          this.sendData.BUSINESS_REPUTATION = this.getReputation();
          this.sendData.GIVE_REPUTATION_DOCS_LATER =
            this.checkedValues.length > 0;
        } else {
          delete this.sendData.BUSINESS_REPUTATION;
          delete this.sendData.GIVE_REPUTATION_DOCS_LATER;
        }
        this.sendData.FOUNDS_BASE_INFO = this.getSourcesArray();
        this.sendData.FOUNDS_BASE_INFO_VALUE = this.anotherFounds;
        this.sendData.FILES = this.createFileList();
        this.$emit("changePageSendData", this.sendData, true);
      }
    },
    getSourcesArray() {
      let a = [];
      this.sources.forEach((item) => {
        if (item.CHECKED) a.push(item.ID);
      });
      return a;
    },
    getReputation() {
      let a = -1;
      this.reputations.forEach((item) => {
        if (item.CHECKED) a = item.ID;
      });
      return a;
    },
    checkUploadFiles(file) {
      let a = false;
      if (this.pageInfo.FILES != null)
        this.pageInfo.FILES.forEach((item) => {
          if (
            item.DESCRIPTION == file.CAPTION &&
            ((file.FILE != null && file.FILE.name != item.DS_FILE_NAME) ||
              file.FILE == null)
          )
            a = true;
        });
      return a;
    },
    createFileList() {
      let files = [];
      this.files.forEach((item) => {
        var a = true;
        if (this.pageInfo.FILES != null) {
          this.pageInfo.FILES.forEach((file) => {
            if (
              file.DESCRIPTION == item.CAPTION &&
              item.FILE != null &&
              item.FILE.name == file.DS_FILE_NAME
            ) {
              a = false;
            }
          });
        }
        if (a && item.FILE != null) {
          files.push(item);
        }
      });
      if (this.pageInfo.FILES != null)
        this.pageInfo.FILES.forEach((file) => {
          var a = true;
          this.files.forEach((item) => {
            if (item.CAPTION == file.DESCRIPTION && item.FILE != null) {
              a = false;
            }
          });
          if (a) {
            files.push({ FILE: null, CAPTION: file.DESCRIPTION });
          }
        });
      return files;
    },
    createFileTable() {
      this.files = [
        {
          id: 0,
          checkbox: false,
          CAPTION:
            "Отзыв(ы) других клиентов " +
            this.bankName +
            ", имеющих с Вами деловые отношения",
          FILE: null,
          unvalid: false,
        },
        {
          id: 1,
          checkbox: false,
          CAPTION:
            "Отзыв(ы) от других кредитных организаций, в которых Вы находились/находитесь на обслуживании, с информацией этих кредитных организаций об оценке Вашей деловой репутации",
          FILE: null,
          unvalid: false,
        },
        {
          id: 2,
          checkbox: false,
          CAPTION: "Иные отзывы/рекомендательные письма",
          FILE: null,
          unvalid: false,
        },
        {
          id: 3,
          checkbox: false,
          CAPTION:
            "Письмо в произвольной форме с указанием сведений и/или источников со сведениями о деловой репутации (сайты, статьи, рейтинги, иное)",
          FILE: null,
          unvalid: false,
        },
        {
          id: 4,
          checkbox: false,
          CAPTION: "Иные сведения",
          FILE: null,
          unvalid: false,
        },
        {
          id: 5,
          checkbox: false,
          CAPTION:
            "Гарантийное письмо о предоставлении информации после начала или возобновления деятельности ( в случае, если деятельность не велась более 3 месяцев или период деятельности не превышает 3 месяцев со дня регистрации)",
          FILE: null,
          unvalid: false,
        },
      ];
    },
  },
  async created() {
    try {
      this.createFileTable();
      if (this.pageInfo.LESS_THREE_MONTHS != null)
        this.lessThreeMonths = this.pageInfo.LESS_THREE_MONTHS;
      this.sendData.INN = this.pageInfo.INN;

      this.sendData.UPDATE_DATE = this.pageInfo.UPDATE_DATE;
      this.sendData.ID = this.pageInfo.ID;
      if (this.pageInfo.IS_BANKRUPT != null)
        this.isBankrupt = this.pageInfo.IS_BANKRUPT;
      if (
        this.pageInfo.GIVE_REPUTATION_DOCS_LATER != null &&
        this.pageInfo.GIVE_REPUTATION_DOCS_LATER
      )
        this.checkedValues = this.tableCheckboxes;
      this.pageInfo.BUSINESS_REPUTATION.forEach(
        (item) => (item.disable = false)
      );
      this.pageInfo.BUSINESS_REPUTATION.sort((a, b) => {
        if (a.ID > b.ID) return 1;
        else if (a.ID == b.ID) return 0;
        else return -1;
      });
      this.pageInfo.FOUNDS_BASE_INFO.sort((a, b) => {
        if (a.ID > b.ID) return 1;
        else if (a.ID == b.ID) return 0;
        else return -1;
      });
      if (this.pageInfo.FILES != null && !this.isBankrupt) {
        let files = this.pageInfo.FILES;
        files.forEach((item) => {
          this.files.forEach((a) => {
            if (a.CAPTION == item.DESCRIPTION) {
              if (item.DS_FILE_NAME != null) {
                a.FILE = { name: item.DS_FILE_NAME };
                a.checkbox = true;
              }
              a.DISABLED = item.DISABLED != null && item.DISABLED;
            }
          });
        });
      }
      this.reputations = this.pageInfo.BUSINESS_REPUTATION;
      if (this.reputations != null) {
        this.reputations.forEach((item) => {
          if (this.lessThreeMonths) {
            if (
              item.VALUE.toLowerCase() ==
              "период деятельности не превышает 3 месяцев со дня регистрации"
            ) {
              this.selectedReputation = item.ID;
              item.CHECKED = true;
            }
          } else {
            if (item.CHECKED) this.selectedReputation = item.ID;
          }
        });
      }
      this.sources = this.pageInfo.FOUNDS_BASE_INFO;
      if (this.isIP) this.sources = this.sources.splice(1);
      if (this.pageInfo.FOUNDS_BASE_INFO_VALUE != null)
        this.anotherFounds = this.pageInfo.FOUNDS_BASE_INFO_VALUE;
      this.reputationsIsLoading = false;
      this.validation();
    } catch (error) {
      console.log(error);
    }
  },
  updated() {
    this.validation();
    this.$emit("updated");
  },
};
</script>

<style scoped>
.main-wrapper {
  text-align: left;
  height: 100%;
}
table {
  border-collapse: collapse;
  width: 100%;
}
.last-column {
  border: 1px solid black;
}
tr {
  border: 1px solid black;
}
td {
  padding: 0px 10px;
}
.main-wrapper-checkboxes {
  display: flex;
  flex-direction: column;
}
label {
  margin-bottom: 5px;
}
input[type="text"] {
  border: none;
  border-bottom: 1px solid #06569b;
  width: 50%;
}
input[type="text"]:focus {
  border-bottom: 1px solid #06569b;
  outline: none;
}
.necessary {
  color: red;
}
.necessary-unvalid {
  border: none;
  border-bottom: 1px solid red;
  width: 100%;
}
.checkboxes {
  display: flex;
  flex-direction: column;
}
.min-one-file {
  text-align: center;
  font-size: 12px;
}
.icons {
  position: absolute;
  padding-left: 255px;
  padding-top: 5px;
  background-color: white;
  border: none;
  color: red;
  font-size: 17px;
}
</style>
